import { AUDIO_FILE_FORMATS, MAX_AUDIO_FILE_SIZE } from '@core/models'

/** Why a picked file was rejected. The container maps these to copy — helpers stay free of i18n. */
export type TAudioFileError = 'invalid-format' | 'too-large'

export const validateAudioFile = (file: File): TAudioFileError | null => {
    if (!AUDIO_FILE_FORMATS.includes(file.type)) {
        return 'invalid-format'
    }

    if (file.size > MAX_AUDIO_FILE_SIZE) {
        return 'too-large'
    }

    return null
}
